export default __webpack_public_path__ + "static/media/linkedinCompany.c8684fe2.svg";